export default __webpack_public_path__ + "static/media/delievers23.a1c9d52c.jpeg";